import { h } from "@stencil/core";
import { uniWatermark } from "../../../license";
export class UniTestUdkComponent {
    connectedCallback() {
        uniWatermark('udk');
    }
    render() {
        return h("h1", null, h("slot", null));
    }
    static get is() { return "uni-test-udk"; }
}
//# sourceMappingURL=test-udk.component.js.map
